class ScrollIndicator {
	constructor() {
		const scrollIndicator = document.querySelector(".banner .scroll-indicator");
		if (scrollIndicator) {
			const banner = document.querySelector("section.banner");
			const nextSibling = banner.nextElementSibling;

			scrollIndicator.addEventListener("click", () => {
				gsap.to(window, {scrollTo: nextSibling, ease: "power2"});
			});
		}
	}
}
